import SimpleCaptcha from '../../../domain/captcha/simple-captcha';
import { updateControl } from '../../../domain/validation/validation';
import { IFormControl } from '../interfaces';

interface IChinaCaptchaField {
    control: IFormControl,
    setSimpleCaptchaCode: Function,
    simpleCaptchaAttempts: number,
}

/**
 * China captcha field.
 */
const ChinaCaptchaField = (props: IChinaCaptchaField) => {
    return (
        <>
            <div className="my-2">
                <SimpleCaptcha
                    simpleCaptchaCode={ props.control.value }
                    setSimpleCaptchaCode={ (value: string) => {
                        props.setSimpleCaptchaCode((updateControl(props.control, value)));
                    }}
                    simpleCaptchaAttempts={ props.simpleCaptchaAttempts }
                />
            </div>

            <div className="text-red text-sm mb-4">
                {
                    !props.control.isValid && <div>{ props.control.error }</div>
                }
            </div>
        </>
    )
};

export default ChinaCaptchaField;